export const projectsData = [
  {
    image: require(`../Data/projects-images/fit-it-on.jpg`),
    tags: [
      "Next.js",
      "React.js",
      "TypeScript",
      "Tailwind CSS",
      "Supabase",
      "Zustand",
    ],
    title: "Fit It On",
    date: "July, 2025",
    details:
      "Fit It On is an AI-powered virtual try-on web app that allows users to visualize how clothing items would look on them before making a purchase. The app offers a clean, modern interface where users can upload a photo of themselves and any clothing image to generate a realistic try-on result using advanced AI models. With privacy and usability in mind, each user's uploads and results are securely stored and accessible through a personalized gallery. The app supports a tiered access system—offering 3 free trials without requiring signup, and premium plans for unlimited use via Lemon Squeezy integration. A responsive layout ensures a smooth experience across all devices, while secure authentication and usage tracking enhance both reliability and performance.",
    liveLink: "https://www.fititon.app/",
    githubLink: null,
  },
  {
    image: require(`../Data/projects-images/realmediagroup.jpg`),
    tags: [
      "Next.js",
      "React.js",
      "SASS",
      "JWT",
      "Node JS",
      "Express.js",
      "MongoDB",
      "next-intl (i18n)",
    ],
    title: "Real Media Group",
    date: "June, 2025",
    details:
      "RealMedia Group is a modern marketing agency website designed to showcase services, share insights, and connect with clients across multiple regions. The entire site is fully multilingual, offering content in four languages to reach a broad international audience. It features a clean, professional design with smooth animations and a responsive layout that works seamlessly on any device. Visitors can explore dynamic pages highlighting the agency’s expertise, read blog articles and news updates, and easily get in touch through integrated contact options. An intuitive admin panel allows authorized users to manage content and publish updates in real time. Overall, the website combines polished visuals with practical tools to support RealMedia Group’s marketing and communication goals.",
    liveLink: "https://www.realmediagroup.com.eg/",
    githubLink: null,
  },
  {
    image: require(`../Data/projects-images/popcorned.jpg`),
    tags: [
      "Next.js",
      "React.js",
      "SASS",
      "Redux",
      "TMDb API",
      "Firebase",
      "Firestore",
    ],
    title: "Popcorned",
    date: "September, 2024",
    details:
      "Popcorned is a web application for movie and TV show enthusiasts to explore the latest releases, write reviews, and keep up with trending content. The app offers simple signup with either email or Google authentication. After signing in, users can create a watchlist to keep track of movies and shows they want to watch. They can also rate and review content, as well as read reviews from others. The account settings page allows users to update their profile picture, email, and password, giving them control over their account. Popcorned provides an easy-to-use platform for discovering new content and sharing opinions with others.",
    liveLink: "https://popcorned.vercel.app/",
    githubLink: "https://github.com/xCordeva/popcorned",
  },
  {
    image: require(`../Data/projects-images/calendizer.jpg`),
    tags: ["Next.js", "React.js", "SASS", "Redux", "Firebase", "Firestore"],
    title: "Calendizer",
    date: "December, 2023",
    details:
      "Calendizer is a user-friendly online planner and organizer that helps users efficiently manage their schedules, tasks, and events. The application starts with an easy signup process, allowing users to register with an email and password or opt for a quicker Google signup. Users can explore the dynamic Calendar page, created with React Big Calendar. This section serves as a CRUD (Create, Read, Update, Delete) page, enabling users to add, edit, or remove events according to their evolving schedules. The Todo List page has the same functionality, providing a similar CRUD experience for task management. Additionally, there's a Dashboard designed to provide users with a quick glance at their day and week. This centralized space consolidates both tasks and events, offering an overview for efficient planning. Whether it's jotting down an upcoming event, managing daily tasks, or checking the Dashboard for a snapshot of your schedule, Calendizer ensures a user-friendly and organized experience.",
    liveLink: "https://xcordeva.github.io/calendizer/",
    githubLink: "https://github.com/xCordeva/calendizer",
  },
  {
    image: require(`../Data/projects-images/my-personal-blog.jpg`),
    tags: ["React.js", "Firebase", "CSS"],
    title: "My Personal Blog",
    date: "November, 2023",
    details:
      "The Cordeva Blog is a personal blogging platform built using React. It allows users to explore blog posts, read articles, and engage with blog posts through comments, and switch between light and dark modes for a personalized experience.",
    liveLink: "https://xcordeva.github.io/my-blog-React-JS/",
    githubLink: "https://github.com/xCordeva/my-blog-React-JS",
  },
  {
    image: require(`../Data/projects-images/interactive-comments.jpg`),
    tags: ["React.js", "Firebase", "CSS"],
    title: "Interactive Comment Section",
    date: "October, 2023",
    details:
      "This is a CRUD React project it simulates a dynamic comments section with features such as a voting system, comment options like editing and deleting, and the ability to reply to comments. It is also connected to a firebase server so anyone with the site link should be able to interact as if he is the current user. It also shows real-time updates to make the user's experience is as real as possible.",

    liveLink:
      "https://xcordeva.github.io/interactive-comments-section-FrontendmentorChallenges/",
    githubLink:
      "https://github.com/xCordeva/interactive-comments-section-FrontendmentorChallenges",
  },
  {
    image: require(`../Data/projects-images/countries-api.jpg`),
    tags: ["HTML", "CSS", "JavaScript", "REST API"],
    title: "Countries API",
    date: "September, 2023",
    details:
      "This is a web application that utilizes the REST Countries API. It implements fetching and displaying data dynamically and also has search and filter functionalities to reach the desired country easily. Additionally, I learned to implement a color theme switcher using CSS variables for a visually appealing design.",
    liveLink:
      "https://xcordeva.github.io/countries-api-with-theme-switcher-FrontendmentorChallenges/",
    githubLink:
      "https://github.com/xCordeva/countries-api-with-theme-switcher-FrontendmentorChallenges",
  },
  {
    image: require(`../Data/projects-images/e-commerce-page.jpg`),
    tags: ["HTML", "CSS", "JavaScript"],
    title: "E-commerce Product Page",
    date: "September, 2023",
    details:
      "A responsive e-commerce website with a focus on optimal layout across various screen sizes. Implemented interactive elements, including a lightbox gallery, enhancing user engagement. User can switch product images, add items to the cart, remove items from cart, and manage their selections.",
    liveLink:
      "https://xcordeva.github.io/ecommerce-product-page-FrontendmentorChallenges/",
    githubLink:
      "https://github.com/xCordeva/ecommerce-product-page-FrontendmentorChallenges",
  },
  {
    image: require(`../Data/projects-images/multi-step-form.jpg`),
    tags: ["HTML", "CSS", "JavaScript"],
    title: "Multi Step Form",
    date: "September, 2023",
    details:
      "In this project, I created a user-friendly web application designed for data collection. The structured form interface guides users through a step-by-step progression, allowing them to navigate forward and backward to update selections. The responsive design ensures an optimal layout across different screen sizes. Notable features include real-time feedback, form validation, and a summary of selections on the final step.",
    liveLink:
      "https://xcordeva.github.io/multi-step-form-FrontendmentorChallenges/",
    githubLink:
      "https://github.com/xCordeva/multi-step-form-FrontendmentorChallenges",
  },
  {
    image: require(`../Data/projects-images/age-calculator.jpg`),
    tags: ["HTML", "CSS", "JavaScript"],
    title: "Age Calculator App",
    date: "September, 2023",
    details:
      "A straightforward web application to calculate a user's age. The user-friendly interface allows users to input a birthdate, and the app calculates and displays the age in years, months, and days. It includes an error handler to ensure accurate results, flagging issues like empty fields or invalid dates. I gained a deep understanding of date manipulation in JavaScript, tackling challenges such as leap years and varying month lengths.",
    liveLink:
      "https://xcordeva.github.io/age-calculator-app-FrontendmentorChallenges/",
    githubLink:
      "https://github.com/xCordeva/age-calculator-app-FrontendmentorChallenges",
  },
  {
    image: require(`../Data/projects-images/tip-calculator.jpg`),
    tags: ["HTML", "CSS", "JavaScript"],
    title: "Tip Calculator App",
    date: "September, 2023",
    details:
      "This project enables users to calculate tips and total costs based on their bill amount, chosen tip percentage, and the number of people sharing the bill. The app provides real-time calculations to make the user's experience is as fast and easy as possible.",
    liveLink:
      "https://xcordeva.github.io/tip-calculator-app-FrontendmentorChallenges/",
    githubLink:
      "https://github.com/xCordeva/tip-calculator-app-FrontendmentorChallenges",
  },
  {
    image: require(`../Data/projects-images/bootstrap-education-website.jpg`),
    tags: ["Bootstrap", "HTML", "CSS"],
    title: "Bootstrap Education Website",
    date: "September, 2023",
    details:
      "This Bootstrap Blockchain Education Website serves as a hands-on learning experience for creating a responsive and visually appealing web design. Focused on blockchain technology, the project is a static website created using Bootstrap, HTML, and CSS. Key features include a responsive design for optimal viewing on different devices, easy navigation, and interactive components. It is important to note that this educational project is for display purposes only and does not contain real data.",
    liveLink:
      "https://xcordeva.github.io/Bootstrap-Blockchain-Education-Website/",
    githubLink:
      "https://github.com/xCordeva/bootstrap-blockchain-education-website",
  },
  {
    image: require(`../Data/projects-images/js-amazon.jpg`),
    tags: ["JavaScript", "HTML", "CSS"],
    title: "JavaScript Amazon Clone",
    date: "August, 2023",
    details:
      "I take great pride in this project, as I independently implemented every dynamic feature in vanilla JavaScript, even though I used HTML and CSS from a tutorial by SuperSimpleDev. The project includes four main pages: Home, Checkout, Order, and Tracking. Features includes efficient search, interactive cart management, detailed order history, local storage to store every action the user makes, and real-time order tracking. The demo showcases these functionalities. Users can browse products, add items to the cart with real-time calculations, place orders, reorder from order history, and track deliveries using the intuitive interface.",
    liveLink: "https://xcordeva.github.io/javascript-amazon-project/",
    githubLink: "https://github.com/xCordeva/javascript-amazon-project",
  },
  {
    image: require(`../Data/projects-images/rock-paper-scissors.jpg`),
    tags: ["JavaScript", "HTML", "CSS"],
    title: "Rock Paper Scissors Game",
    date: "August, 2023",
    details:
      "The classic Rock Paper Scissors game. With lots of features including Auto Play for hands-free fun, keyboard controls (a) for auto play and (Backspace) for score reset, real-time showing results, and score tracking. An intro message based on the user's previous game outcomes.",
    liveLink: "https://xcordeva.github.io/Rock-Paper-Scirssors-Game/",
    githubLink: "https://github.com/xCordeva/Rock-Paper-Scirssors-Game",
  },
];
